class BD_Storage {
  state = null;
  // read only
  defaultState = {
    timerRemaining: {
      // {$blockId}: int in seconds
    },
  };

  load() {
    const state = localStorage.getItem("bd-" + CFG.GP);
    this.state = state ? JSON.parse(state) : this.defaultState;
  }

  save(key, value) {
    this.state[key] = value;
    localStorage.setItem("bd-" + CFG.GP, JSON.stringify(this.state));
  }

  delete() {
    localStorage.removeItem("bd-" + CFG.GP);
  }
}
